import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user && user !== false && user !== null) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      nav("/admin/dashboard");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#050816] text-white flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 hero-glow opacity-60" aria-hidden />
      <div className="absolute inset-0 grid-bg opacity-30" aria-hidden />
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <Logo size="lg" />
        </Link>

        <div className="p-8 rounded-3xl glass-strong" data-testid="admin-login-card">
          <div className="overline">Admin Access</div>
          <h1 className="mt-3 font-display text-3xl font-bold tracking-tight">Sign in to dashboard</h1>
          <p className="mt-2 text-sm text-gray-400">Manage leads, newsletter and stats.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <div className="space-y-2">
              <Label className="text-xs text-gray-400">Email</Label>
              <Input required type="email" data-testid="admin-login-email" value={email} onChange={(e)=>setEmail(e.target.value)}
                className="bg-black/30 border-white/10 focus-visible:ring-[#2563EB]" placeholder="admin@alphatechlabz.com"/>
            </div>
            <div className="space-y-2">
              <Label className="text-xs text-gray-400">Password</Label>
              <Input required type="password" data-testid="admin-login-password" value={password} onChange={(e)=>setPassword(e.target.value)}
                className="bg-black/30 border-white/10 focus-visible:ring-[#2563EB]" placeholder="Enter password"/>
            </div>
            {error ? (
              <div data-testid="admin-login-error" className="text-sm text-red-400">{error}</div>
            ) : null}
            <Button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full btn-glow bg-[#2563EB] hover:bg-[#1d4ed8] rounded-full h-11"
            >
              {loading ? "Signing in..." : (<>Sign in <ArrowRight className="ml-2 w-4 h-4"/></>)}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/" className="text-xs text-gray-500 hover:text-white">← Back to site</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
